import { lazy } from 'react';

const Excel = lazy(() => import('./Excel'));

export default Excel;
